export default __webpack_public_path__ + "static/media/6.27c970f5.jpg";